import React from "react";
import { Typography, Box, Icon } from "@mui/material";

const emptyData = ({ icon, fontSize, title, message, sx, sxIcon }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        padding: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        rowGap: 1,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          backgroundColor: "gray-background.main",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: 1,
          borderColor: "light-gray-text.main",
          mb: 1.5,
        }}
      >
        <Icon
          sx={{
            fontSize: fontSize ? fontSize : 40,
            color: "light-gray-text.main",
            ...sxIcon
          }}
        >
          {icon}
        </Icon>
      </Box>
      <Typography
        variant="h4"
        align="center"
        sx={{ color: "light-gray-text-2.main" }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        align="center"
        sx={{ color: "light-gray-text-2.main" }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default emptyData;
